var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"currentColor","cx":"12","cy":"12","r":"10","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"m12 9.16a1.1 1.1 0 1 1 1.128-1.1 1.073 1.073 0 0 1 -1.128 1.1zm-.95 1.552c0-.4.082-.718.95-.718s.951.315.951.718v5.879c0 .4-.082.718-.951.718s-.95-.315-.95-.718z","key":1})]);
}

InfoIcon.defaultProps = {"data-dmid":"dm-info","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
